import type { RouteObject } from 'react-router-dom'

const securityRoute: RouteObject = {
  children: [
    { lazy: () => import('@/pages/security/roles/index/page'), path: 'roles' },
    { lazy: () => import('@/pages/security/roles/create/page'), path: 'roles/create' },
    { lazy: () => import('@/pages/security/roles/edit/page'), path: 'roles/:roleId' },
    { lazy: () => import('@/pages/security/data-group/page'), path: 'data-group' },
    { lazy: () => import('@/pages/security/user-account-list/page'), path: 'user-account-list' },
  ],

  path: 'security',
}

export default securityRoute
